import { MinistryStatus } from "../generated/api-client";

export const ministryStatusValues: MinistryStatus[] = [
    "Active",
    "Licensed",
    "Retired",
    "Terminated",
];

export const ministryStatusLabels: Record<MinistryStatus, string> = {
    Active: "En actividad",
    Licensed: "De licencia",
    Retired: "En descanso",
    Terminated: "Terminado",
};

export const ministryStatusOptions = ministryStatusValues.map(value => ({
    value,
    label: ministryStatusLabels[value],
}));
